import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import InvitePage from './pages/InvitePage';
import Dashboard from './pages/Dashboard';
import TentativePage from './pages/TentativePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<InvitePage />} />
        <Route path="/suha-and-hasan" element={<InvitePage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/tentative" element={<TentativePage />} />
        <Route path="/suha-and-hasan/dashboard" element={<Dashboard />} />
        <Route path="/suha-and-hasan/dashboard/tentative" element={<TentativePage />} />
        {/* New path-based invite link — hyperlinks more reliably in SMS.
            Old ?guestId= links still work via the /suha-and-hasan route above. */}
        <Route path="/suha-and-hasan/:guestId" element={<InvitePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
